import { render, staticRenderFns } from "./JurnalKelas.vue?vue&type=template&id=7a45652c"
import script from "./JurnalKelas.vue?vue&type=script&lang=js"
export * from "./JurnalKelas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports